module.exports = __webpack_public_path__ + "img/empty_box.4d434b68.png";